export var getGoldBenefitBadgeSize = function (isMobileViewport) {
    return isMobileViewport ? '45px' : '66px';
};
